import { createContext, useState ,useEffect} from "react";
const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(localStorage.getItem('ROLE'));

    useEffect(() => {
        localStorage.setItem("ROLE",auth)
      }, [auth]);

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;